import React, { useState } from "react";
import { Drawer, DrawerContent, useDisclosure } from "@heroui/react";
import ButtonMethodPayment from "../../components/ButtonMethodPayment";
import Invoice from "../../components/Invoice";
import { ReactComponent as Close } from "../../assets/close.svg";
import { ReactComponent as CardIcon } from "../../assets/card_blue.svg";
import FormCreditCard from "../../components/FormCreditCard";
import { InvoiceTypes } from "../../lib/interfaces";
import ButtomSave from "../../components/ButtomSave";
import { isMobile } from "react-device-detect";
import { useStore } from "../../lib/store";
import axios from "axios";
import { toast } from "sonner";
import PaymentStatus from "../../components/PaymanetStatus";
import RegisterCard from "./RegisterCard";
import { AmplitudeLog } from "../../lib/amplitude";
import { ScrollArea } from "../../components-shadcn/scroll-area";

interface Props {
  invoice: InvoiceTypes;
  wide?: boolean
  error?: string;
}

type IconKey = "error" | "success" | "processing";

interface TypePaymentStatus {
  open: boolean;
  icon: IconKey;
  title: string;
  legend: string;
}

const PaymentCreditCardAreaCliente: React.FC<Props> = ({ invoice, wide, error }) => {

  const { credit_card } = useStore();
  const { set_sync_invoices } = useStore();
  const { user } = useStore();
  const { external_link } = useStore();

  const [status_payment, set_status_payment] = useState<TypePaymentStatus>({
    open: false,
    icon: "processing",
    title: "",
    legend: "",
  });

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [loading, set_loading] = useState(false);

  const PayInvoice = async () => {
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/pay_invoice",
        {
          invoice: invoice?.id_fatura.toString(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_status_payment({
          icon: "success",
          title: "Pagamento aprovado!",
          legend:
            "O pagamento foi aprovado com sucesso! Enviaremos a NF-e para o e-mail financeiro cadastrado.",
          open: true,
        });
        set_loading(false);
        set_sync_invoices(true);
      } else {
        set_status_payment({
          icon: "error",
          title: "Falha no pagamento",
          legend: resposta.data.msg,
          open: true,
        });
        set_loading(false);
      }
    } catch (erro: any) {
      toast("Erro ao pagar fatura: " + erro.message, {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      set_loading(false);
    }
  };

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40" />}

      <ButtonMethodPayment
        onClick={() => {
          AmplitudeLog("Op_cartao_pagamento", { user_id: user });
          onOpen();
        }}
        icon="cartao"
        theme="mediumgreen"
        wide={wide}
        error={error && error !== "" ? "Encontramos problemas com o cartão" : undefined}
      >
        Pague com Cartão
      </ButtonMethodPayment>

      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement={"bottom"}
        hideCloseButton
        onClose={() =>
          set_status_payment({
            icon: "processing",
            legend: "",
            open: false,
            title: "",
          })
        }
      >
        <DrawerContent
          className={`
          w-full
          rounded-t-[0.75rem]
          ${!isMobile && "!h-[100vh] !rounded-none !border-none"}
          !max-h-screen
          bg-white-primary
          px-[2rem]
          flex items-center
        `}
        >
          {(onClose) => (
            <div
              className={`${external_link && !isMobile ? "w-[60%]" : "w-full"}`}
            >
              <div className="w-[100%] flex justify-end">
                <button
                  onClick={onClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    marginTop: "1.5rem",
                  }}
                >
                  <Close className="w-[1rem] h-[1rem]" />
                </button>
              </div>
              <ScrollArea className="h-[100%]">
                <div className="w-[100%] flex justify-center">
                  <p className="text-blue-primary text-[1.04rem] font-[700]">
                    Pagamento com Cartão
                  </p>
                </div>
                <p className="text-gray-dark text-[1.04rem] mt-[1.8rem] font-[700]">
                  Fatura
                </p>
                <Invoice
                  duedate={invoice?.vencimento}
                  price={invoice?.preco}
                  theme="default"
                />
                <hr />
                {credit_card?.name ? (
                  <div className="mb-[2rem]">
                    <p className="text-gray-dark text-[1.2rem] mt-[1.4rem] font-[700] my-[2rem]">
                      Cadastrar cartão
                    </p>
                    <div className="flex flex-col p-[0.75rem] border border-gray-medium rounded-[0.5rem]">
                      <p>Cartão cadastrado</p>
                      <div className="flex flex-row">
                        <CardIcon className="w-[1.3rem] h-[1.3rem] mr-[1rem] mt-[0.5rem]" />
                        <p className="mt-[0.5rem]">{credit_card.num_card}</p>
                      </div>
                    </div>
                    <RegisterCard dotMode />
                    <ButtomSave
                      theme="mediumgreen"
                      icon="none"
                      className="mt-[2rem]"
                      loading={loading}
                      onClick={() => {
                        PayInvoice();
                        AmplitudeLog("Pagar_cartao_cadastrado_pagamento", {
                          user_id: user,
                        });
                      }}
                    >
                      Pagar com cartão cadastrado
                    </ButtomSave>
                  </div>
                ) : (
                  <FormCreditCard invoice={invoice.id_fatura.toString()} name_button="Pagar fatura" />
                )}
              </ScrollArea>

              <PaymentStatus
                open={status_payment.open}
                icon={status_payment.icon}
                title={status_payment.title}
                legend={status_payment.legend}
              />
            </div>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default PaymentCreditCardAreaCliente;
